function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.109.25C3.78.25.274 3.719.274 8c0 4.281 3.507 7.75 7.835 7.75 4.328 0 7.834-3.469 7.834-7.75 0-4.281-3.506-7.75-7.834-7.75zm0 14C4.602 14.25 1.79 11.469 1.79 8c0-3.438 2.811-6.25 6.318-6.25 3.475 0 6.318 2.813 6.318 6.25 0 3.469-2.843 6.25-6.318 6.25zm3.19-8.188c.158-.125.158-.375 0-.53l-.695-.688c-.157-.157-.41-.157-.537 0L8.11 6.78l-1.99-1.937c-.127-.157-.38-.157-.537 0l-.695.687c-.158.157-.158.407 0 .532L6.845 8 4.887 9.969c-.158.125-.158.375 0 .531l.695.688c.158.156.41.156.537 0l1.99-1.938 1.958 1.938c.127.156.38.156.537 0l.695-.688c.158-.156.158-.406 0-.531L9.341 8l1.958-1.938z",
  fill: "currentColor"
});

var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _ref);
};

export default SvgCloseCircle;